import { HorizonInterval } from '../Horizon';
import Tag from '../Tag';
import ReportFieldDto from './ReportFieldDto';
import ReportHorizonDto from './ReportHorizonDto';
import ReportTownshipDto from './ReportTownshipDto';
import ReportTractDto from './ReportTractDto';

export default class ReportDataTree {
    id: number;
    parentId: number;
    reportTier: number;
    reportText: string;
    reportGlobal: string;
    selected: boolean;
    expanded: boolean;
    tags: Tag[];
    children: ReportDataTree[];

    static FromTownships(townships: ReportTownshipDto[], parentGlobal: string, fieldType: string) {
        let treeList: ReportDataTree[] = [];

        for (let t of townships) {
            const tree: ReportDataTree = {
                id: t.id,
                parentId: 0,
                reportTier: 1,
                reportText: t.townshipName,
                reportGlobal: t.townshipName,
                selected: false,
                expanded: false,
                tags: [],
                children: t.fieldList?.length > 0 ? ReportDataTree.FromFields(t.fieldList, t.id, parentGlobal, fieldType) : []
            };

            treeList.push(tree);
        }

        return treeList;
    }

    static FromFields(fields: ReportFieldDto[], parentId: number, parentGlobal: string, fieldType: string) {
        let treeList: ReportDataTree[] = [];
        
        for (let f of fields) {
            let newParent = `${parentGlobal},${f.globalNumber}`;
            let fieldName = f.fieldName?.trim() ?? '';

            const tree: ReportDataTree = {
                id: f.id,
                parentId: parentId,
                reportTier: 2,
                reportText: `${fieldType} ${f.fieldNumber}${fieldName.length > 0 ? ' - ' + fieldName : ''}`,
                reportGlobal: newParent,
                selected: false,
                expanded: false,
                tags: [],
                children: f.tractList?.length > 0 ? ReportDataTree.FromTracts(f.tractList, f.id, newParent) : []
            };

            treeList.push(tree);
        }

        return treeList;
    }

    static FromTracts(tracts: ReportTractDto[], parentId: number, parentGlobal: string) {
        let treeList: ReportDataTree[] = [];

        for (let t of tracts) {
            const acres = t?.grossAcres ?? t?.horizonList?.[0]?.grossAcres ?? 0;

            const tree: ReportDataTree = {
                id: t.id,
                parentId: parentId,
                reportTier: 3,
                reportText: `Tract ${t.tractNumber} - ${acres} Acres`,
                reportGlobal: `${parentGlobal},${t.tractNumber}`,
                selected: false,
                expanded: false,
                tags: t.tags,
                children: t.horizonList?.length > 0 ? ReportDataTree.FromHorizons(t.horizonList, t.id) : []
            };

            treeList.push(tree);
        }

        return treeList;
    }

    static FromHorizons(horizons: ReportHorizonDto[], parentId: number = 0) {
        let treeList: ReportDataTree[] = [];

        for (let h of horizons) {
            let horizonDetailDisplay = `Horizon ${h.horizonNumber}`;
            if (!!h.from && !!h.to) {
                let interval = HorizonInterval.fromSummary(h);
                interval.to.calcType();
                interval.from.calcType();
                horizonDetailDisplay += ' - From ' + interval.from.toString() + ' To ' + interval.to.toString();
            }
            let hGlobal = h.globalId.split('.');
            let horizonGlobal = hGlobal.join(',');
            horizonGlobal = horizonGlobal.replace('-', ',');

            const tree: ReportDataTree = {
                id: h.id,
                parentId: parentId,
                reportTier: 4,
                reportText: horizonDetailDisplay,
                reportGlobal: horizonGlobal,
                selected: false,
                expanded: false,
                tags: [],
                children: []
            };

            treeList.push(tree);
        }

        return treeList;
    }
}



// WEBPACK FOOTER //
// ./src/models/reports/ReportDataTree.ts